import React from "react";
import {
  TextBlock,
  MediaBlock,
  TextRow,
  RectShape,
  RoundShape
} from "react-placeholder/lib/placeholders";
import { Panel, Row, Col } from "react-bootstrap";
import CommonLoading from "../common_components/Loading";

export default class Loading extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { rootStore } = this.props;

    if (rootStore.isCeoBoard) {
      return (
        <div className="react-board">
          <div className="loader-lg">
            <div />
          </div>
        </div>
      );
    } else if (rootStore.isTaskBoard) {
      return <CommonLoading />;
    } else {
      return <div>ERROR_LOADING</div>;
    }
  }
}

/*

  return (
                <div className='react-board'>
                    <br/>
                    <div className="lane-to_do col-sm-4">
                        <Panel>
                            <div className="lane-list-container">
                                <div className="lane-header">
                                    <TextRow rows={1} color='#d4d4d4'/>
                                </div>
                                <br/><br/>
                                <TextBlock rows={13} color='#d4d4d4'/>
                            </div>
                        </Panel>
                    </div>
                    <div className="lane-to_do col-sm-4">
                        <Panel>
                            <div className="lane-list-container">
                                <div className="lane-header">
                                    <TextRow rows={1} color='#d4d4d4'/>
                                </div>
                                <br/><br/>
                                <TextBlock rows={5} color='#d4d4d4'/>
                            </div>
                        </Panel>
                    </div>
                    <div className="lane-to_do col-sm-4">
                        <Panel>
                            <div className="lane-list-container">
                                <div className="lane-header">
                                    <TextRow rows={1} color='#d4d4d4'/>
                                </div>
                                <br/><br/>
                                <TextBlock rows={17} color='#d4d4d4'/>
                            </div>
                        </Panel>
                    </div>
                </div>
            );

            */
